import { render, staticRenderFns } from "./List.vue?vue&type=template&id=27e002fe&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=27e002fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e002fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e002fe')) {
      api.createRecord('27e002fe', component.options)
    } else {
      api.reload('27e002fe', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=27e002fe&scoped=true&", function () {
      api.rerender('27e002fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserHistory/List.vue"
export default component.exports